import { useRef } from 'react';
import { Icone } from '../Icone';
import { Modale } from '../ui/Modale';
import { BoutonPrincipal, BoutonSecondaire } from '../ui/Primitives';
import { useToast } from '../ui/useToast';

/**
 * Lien d'invitation rendu à la direction quand l'e-mail n'est pas parti
 * (TF-500, décision du 04/11/2026) : elle le transmet elle-même. L'API ne le
 * garde nulle part — fermée, la fenêtre ne le rendra plus ; un renvoi en
 * produit un autre.
 */
export function ModaleLienInvitation({
  destinataire,
  lien,
  validiteJours,
  onFermer,
}: {
  destinataire: { prenom: string; nom: string; email: string };
  lien: string;
  validiteJours: number;
  onFermer: () => void;
}): JSX.Element {
  const toast = useToast();
  const champ = useRef<HTMLInputElement>(null);

  const copier = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(lien);
      toast('Lien copié');
    } catch {
      // Sans presse-papiers (page non sécurisée, refus du navigateur), le lien est sélectionné.
      champ.current?.select();
      toast('Lien sélectionné : copiez-le avec Ctrl+C');
    }
  };

  return (
    <Modale titre="Lien d’invitation à transmettre" ouverte onFermer={onFermer}>
      <div className="space-y-5 p-4 sm:p-6">
        <p className="text-sm text-codialis-navy">
          L’e-mail n’est pas parti. Transmettez ce lien à {destinataire.prenom} {destinataire.nom} (
          {destinataire.email}) par un canal sûr : il est valable {validiteJours} jours, ne sert qu’une fois et ne
          sera plus affiché.
        </p>
        <div>
          <label
            htmlFor="lien-invitation"
            className="mb-2 block text-[11px] font-bold uppercase tracking-wide text-codialis-gray"
          >
            Lien d’invitation
          </label>
          <div className="flex min-w-0 flex-col gap-2 sm:flex-row">
            <input
              id="lien-invitation"
              ref={champ}
              readOnly
              value={lien}
              onFocus={(evenement) => evenement.target.select()}
              className="min-w-0 flex-1 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 font-mono text-xs text-codialis-navy"
            />
            <BoutonSecondaire onClick={() => void copier()}>
              <Icone nom="copier" className="mr-2 h-4 w-4" />
              Copier
            </BoutonSecondaire>
          </div>
        </div>
        <div className="flex justify-end">
          <BoutonPrincipal onClick={onFermer}>Terminé</BoutonPrincipal>
        </div>
      </div>
    </Modale>
  );
}
